import { InlineAlert } from '../../../../components/InlineAlert';
import { translate } from '../../../../services/i18n';

import {
  StyledNotEcommerceContent,
  StyledNotEcommerceUnreportedText,
  StyledNotEcommerceReportWrapper,
  StyledNotEcommerceIcon,
  StyledNotEcommerceTitle,
  StyledNotEcommerceSubtitle,
} from './styles';

type NotEcommerceViewProps = {
  isAlreadyReported: boolean;
  onReport: () => void;
  isReportSent: boolean;
  isReportLoading: boolean;
};

export const NotEcommerceView = ({
  isAlreadyReported,
  onReport,
  isReportSent,
  isReportLoading,
}: NotEcommerceViewProps) => (
  <StyledNotEcommerceContent>
    <StyledNotEcommerceIcon iconName="company-empty-suggestions" />
    <StyledNotEcommerceTitle>
      {translate(isReportSent ? 'company.ecommerce.empty.feedback.title' : 'company.ecommerce.empty.title')}
    </StyledNotEcommerceTitle>
    <StyledNotEcommerceSubtitle>
      {translate(isReportSent ? 'company.ecommerce.empty.feedback.subtitle' : 'company.ecommerce.empty.subtitle')}
    </StyledNotEcommerceSubtitle>
    {!isReportSent ? (
      isAlreadyReported ? (
        <InlineAlert variant="info" margin="24px 0 0">
          {translate('company.ecommerce.empty.reported')}
        </InlineAlert>
      ) : (
        <InlineAlert variant="info" margin="24px 0 0">
          <StyledNotEcommerceReportWrapper>
            {translate('company.ecommerce.empty.unreported')}
            <StyledNotEcommerceUnreportedText onClick={onReport} disabled={isReportLoading}>
              {translate('company.ecommerce.empty.report-button')}
            </StyledNotEcommerceUnreportedText>
          </StyledNotEcommerceReportWrapper>
        </InlineAlert>
      )
    ) : null}
  </StyledNotEcommerceContent>
);
